import { motion } from "framer-motion";
import { FadeIn } from "@/components/FadeIn";
import { Check, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Packages = ({ content }) => {
  const { t, tc } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const packages = content.packages || [];
  return (
    <section id="pakete" data-testid="packages-section" className="py-24 md:py-32 bg-blue-50/60 border-y border-slate-200">
      <div className="container-x">
        <FadeIn className="max-w-2xl mb-16">
          <span className="overline">{t("packages.overline")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">{t("packages.title")}</h2>
          <p className="text-slate-500 md:text-lg">{t("packages.subtitle")}</p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {packages.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`package-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`relative rounded-3xl p-8 flex flex-col transition-all duration-300 hover:-translate-y-1.5 ${p.featured ? "bg-slate-900 text-white shadow-2xl shadow-blue-900/30 ring-2 ring-blue-600" : "bg-white border border-slate-200 shadow-sm hover:shadow-xl hover:shadow-blue-600/10"}`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-semibold px-4 py-1 rounded-full">
                  {t("packages.popular")}
                </span>
              )}
              <div className="flex items-center gap-2 mb-1">
                <span className={`text-xs font-semibold uppercase tracking-widest ${p.featured ? "text-blue-300" : "text-blue-600"}`}>{tc(p.name)}</span>
                <span className={`inline-flex items-center gap-1 text-xs ${p.featured ? "text-slate-300" : "text-slate-400"}`}><Clock className="w-3 h-3" /> {tc(p.duration)}</span>
              </div>
              <h3 className={`text-2xl font-bold mb-4 ${p.featured ? "text-white" : "text-slate-900"}`}>{tc(p.title)}</h3>

              <ul className="space-y-3 flex-1">
                {(p.items || []).map((it, j) => (
                  <li key={j} className="flex items-start gap-3">
                    <span className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${p.featured ? "bg-blue-600" : "bg-blue-100"}`}>
                      <Check className={`w-3 h-3 ${p.featured ? "text-white" : "text-blue-600"}`} />
                    </span>
                    <span className={`text-sm ${p.featured ? "text-slate-200" : "text-slate-600"}`}>{tc(it)}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 pt-6 border-t border-dashed border-slate-200/60">
                <div className={`text-3xl font-extrabold mb-4 ${p.featured ? "text-white" : "text-slate-900"}`}>{tc(p.price)}</div>
                <button
                  data-testid={`package-cta-${i}`}
                  onClick={() => scrollTo("termin")}
                  className={p.featured ? "btn-blue w-full" : "btn-ghost w-full"}
                >
                  {t("packages.cta")}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
